'use client'

import dynamic from 'next/dynamic'

export function VideoClassFilterButtonLoader({
  template,
}: {
  template: string | null
}) {
  const VideoClassFilterButton = dynamic(
    () =>
      import(
        `@/components/${template}/global/video-class-filter-button`
      ).catch(() => {
        return Promise.resolve(() => null)
      }),
    { ssr: false }
  )

  return <VideoClassFilterButton />
}
